module.exports = __webpack_public_path__ + "img/en.6c4b7c7d.png";